import React, { ReactElement } from 'react'

import { ButtonClick, track } from '@dfds-frontend/tracking'
import { BffInterfacesBasket } from '@dfds-pax/booking-experience-bff'

import Dialog from '@/app/[locale]/[ferry]/Dialog'

import { useTranslation } from '@/hooks/useDebugTranslations'

type Props = {
  close: () => void
  isOpen: boolean
  recoveredBasketErrors: BffInterfacesBasket.RecoveredBasketErrors
}

const RecoveredBasketInfoModal: React.FC<Props> = ({ close, isOpen, recoveredBasketErrors }: Props): ReactElement => {
  const { t } = useTranslation()
  let heading: string | undefined
  let bodytext: string | undefined

  if (recoveredBasketErrors.dates && recoveredBasketErrors.dates.length > 0) {
    heading = t('DATE-CHANGED-POPUP-HEADER')
    bodytext = t('DATE-CHANGED-POPUP-BODY')
  } else if (recoveredBasketErrors.departures && recoveredBasketErrors.departures.length > 0) {
    heading = t('CAPACITY-CHANGED-POPUP-HEADER')
    bodytext = t('CAPACITY-CHANGED-POPUP-BODY')
  } else if (recoveredBasketErrors.addon && recoveredBasketErrors.addon.length > 0) {
    heading = t('CAPACITY-CHANGED-POPUP-HEADER')
    bodytext = t('CAPACITY-CHANGED-POPUP-BODY')
  } else if (recoveredBasketErrors.price && recoveredBasketErrors.price.length > 0) {
    heading = t('PRICE-CHANGED-POPUP-HEADER')
    bodytext = t('PRICE-CHANGED-POPUP-BODY')
  }

  const onClose = () => {
    track<ButtonClick>({
      clickedElementText: heading ?? '',
      event: 'buttonClick',
      eventAction: 'recoverBasketFailed',
    })
    close()
  }

  return (
    <Dialog
      dataAttr="recover-basket"
      description={bodytext ?? ''}
      headline={heading ?? ''}
      onPrimaryButtonClicked={() => onClose()}
      onRequestClose={() => onClose()}
      primaryButtonText={t('BUTTON-CONTINUE')}
      show={isOpen}
    />
  )
}

export default RecoveredBasketInfoModal
